module.exports = __webpack_public_path__ + "img/cpp.b90bf37f.svg";